import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationNotificationSettingReducer} from '../../utils/types';
//actions
import {
	organizationGetVipPhones,
	organizationAddVipPhone,
	organizationDeleteVipPhone,
	organizationGetNotificationSettings,
	organizationUpdateNotificationSettings,
} from './actions';
//operations
import {
	addVipPhoneNumber,
	getVipPhoneNumbers,
	pendingOperation,
	rejectedOperation,
	deleteVipPhoneNumber,
	getNotificationSetting,
	updateNotificationSetting,
} from './operations';

export const initialState: IOrganizationNotificationSettingReducer = {
	organizationVipPhones: [],
	organizationSetting: null,
	isLoading: false,
};

const organizationNotificationStore = createSlice({
	name: 'organizationNotification',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(organizationGetVipPhones.pending, pendingOperation);
		builder.addCase(organizationGetVipPhones.fulfilled, getVipPhoneNumbers);
		builder.addCase(organizationGetVipPhones.rejected, rejectedOperation);

		builder.addCase(organizationAddVipPhone.pending, pendingOperation);
		builder.addCase(organizationAddVipPhone.fulfilled, addVipPhoneNumber);
		builder.addCase(organizationAddVipPhone.rejected, rejectedOperation);

		builder.addCase(organizationDeleteVipPhone.pending, pendingOperation);
		builder.addCase(organizationDeleteVipPhone.fulfilled, deleteVipPhoneNumber);
		builder.addCase(organizationDeleteVipPhone.rejected, rejectedOperation);

		builder.addCase(organizationGetNotificationSettings.pending, pendingOperation);
		builder.addCase(organizationGetNotificationSettings.fulfilled, getNotificationSetting);
		builder.addCase(organizationGetNotificationSettings.rejected, rejectedOperation);

		builder.addCase(organizationUpdateNotificationSettings.pending, pendingOperation);
		builder.addCase(organizationUpdateNotificationSettings.fulfilled, updateNotificationSetting);
		builder.addCase(organizationUpdateNotificationSettings.rejected, rejectedOperation);
	},
});

export default organizationNotificationStore.reducer;
